import React, { useState, useEffect } from "react";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ProgressTracker from "../components/ProgressTracker";

const API_WRK = process.env.REACT_APP_API_WRK;

const VerifyPhone = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [message, setMessage] = useState("");
  const [step, setStep] = useState(1);

  const navigate = useNavigate();
  const workerEmail =
  localStorage.getItem("workerEmail") ||
  localStorage.getItem("userEmail") ||
  localStorage.getItem("email");

  useEffect(() => {
  const emailCheck =
    localStorage.getItem("workerEmail") ||
    localStorage.getItem("userEmail") ||
    localStorage.getItem("email");

  if (!emailCheck) {
    console.warn("⚠️ No worker email found, redirecting to login...");
    setTimeout(() => navigate("/worker-login"), 800);
  }
}, [navigate]);

  // 🧩 Step progress tracking
  const steps = [
    { label: "Legal Name", completed: true },
    { label: "Verify Phone", completed: false },
    { label: "Set Address", completed: false },
    { label: "Upload Documents", completed: false },
  ];

  // ✅ Setup invisible reCAPTCHA
  const setupRecaptcha = () => {
    console.log("🧩 Setting up reCAPTCHA...");

    if (!auth || typeof window === "undefined") {
      console.error("❌ Firebase Auth not initialized or window is undefined.");
      setMessage("❌ Something went wrong. Try again.");
      return;
    }

    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
    }

    try {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => console.log("✅ reCAPTCHA solved:", response),
          "expired-callback": () =>
            console.warn("⚠️ reCAPTCHA expired. Please retry."),
        }
      );

      window.recaptchaVerifier.render().then((widgetId) => {
        window.recaptchaWidgetId = widgetId;
        console.log("🎯 reCAPTCHA rendered:", widgetId);
      });
    } catch (err) {
      console.error("❌ reCAPTCHA setup failed:", err);
      setMessage("❌ Could not initialize reCAPTCHA.");
    }
  };

  // ✅ Send OTP
  const handleSendOTP = async () => {
    console.log("📩 Sending OTP to:", phone);

    if (!phone.startsWith("+1")) {
      setMessage("❌ Use +1 format for Canadian numbers.");
      return;
    }

    setupRecaptcha();

    try {
      const appVerifier = window.recaptchaVerifier;
      const result = await signInWithPhoneNumber(auth, phone, appVerifier);
      setConfirmationResult(result);
      setStep(2);
      setMessage("✅ OTP sent! Check your phone.");
    } catch (err) {
      console.error("❌ Firebase OTP error:", err);
      setMessage("❌ Failed to send OTP. Make sure the phone number is correct.");
    }
  };

  // ✅ Verify OTP
  const handleVerifyOTP = async () => {
    if (!otp.trim()) {
      alert("Please enter the OTP");
      return;
    }

    try {
      const confirmed = await confirmationResult.confirm(otp);
      console.log("✅ OTP verified:", confirmed);

      await axios.post(`${API_WRK}/save-phone`, {
        email: workerEmail,
        phone,
      });

      localStorage.setItem("workerPhone", phone);
      setMessage("✅ Phone verified and saved!");
      setTimeout(() => navigate("/set-address"), 800);
    } catch (err) {
      console.error("❌ OTP verification failed:", err);
      setMessage("❌ Invalid or expired OTP. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* 🧭 Progress Bar */}
      <ProgressTracker steps={steps} currentStep="Verify Phone" />

      {/* 📱 Main Content */}
      <div className="flex flex-1 items-center justify-center px-4">
        <div className="bg-white shadow-lg rounded-2xl p-6 w-full max-w-sm text-center border border-gray-100">
          <h1 className="text-2xl font-bold text-indigo-700 mb-4">
            Verify Your Phone
          </h1>

          {step === 1 ? (
            <>
              <input
                type="tel"
                placeholder="+1XXXXXXXXXX"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg mb-3 focus:ring-2 focus:ring-indigo-500"
              />
              <button
                onClick={handleSendOTP}
                className="w-full bg-indigo-600 text-white py-2 rounded-lg font-medium hover:bg-indigo-700 transition-all"
              >
                Send OTP
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg mb-3 focus:ring-2 focus:ring-green-500"
              />
              <button
                onClick={handleVerifyOTP}
                className="w-full bg-green-600 text-white py-2 rounded-lg font-medium hover:bg-green-700 transition-all"
              >
                Verify OTP
              </button>
            </>
          )}

          {message && (
            <p
              className={`mt-4 text-sm font-medium ${
                message.startsWith("❌") ? "text-red-600" : "text-green-600"
              }`}
            >
              {message}
            </p>
          )}
          <div id="recaptcha-container" className="mt-3" />
        </div>
      </div>
    </div>
  );
};

export default VerifyPhone;
